<template>
  <BaseModal
    :show="show"
    @close="close"
  >
    <div>
      <h3
        class="font-extrabold"
        v-text="'Delete Link'"
      />
    </div>
    <div
      v-if="link"
      class="modal-body"
    >
      <p>Are you sure you want to delete <em>{{ title }}</em>?</p>
    </div>
    <div class="modal-footer">
      <button
        class="btn btn-blue"
        @click="destroy"
        v-text="'Delete'"
      />
      <a
        href="#"
        class="mx-4 px-2"
        @click.prevent="close"
        v-text="'Cancel'"
      />
    </div>
  </BaseModal>
</template>

<script type="text/babel">
export default {
  name: 'DeleteLinkModal',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    link() {
      return this.$store.state.resource.deleteLinkModal.link
    },
    title() {
      return this.$store.state.resource.deleteLinkModal.link.attributes.title
    },
  },
  methods: {
    destroy() {
      this.$api.active().delete(`links/${this.link.uuid}`).then(() => {
        this.$emit('destroyed')

        this.$store.commit('baseAddNotification', {
          type: 'success',
          title: 'Success',
          text: 'Link Deleted!',
        })

        this.close()
      }).catch(() => {
        this.$store.commit('baseAddNotification', {
          type: 'error',
          title: 'Error',
          text: 'An Error Occurred!',
        })

        this.close()
      })
    },
    close() {
      this.$store.commit('resourceCloseDeleteLinkModal')
    },
  },
}
</script>
